import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../helpers/AsyncFunc';

class AppRouter extends React.Component<any, any> {
    public render() {
        const { url } = this.props;
        console.log('[APP_ROUTER] Attempting to route to : ', url);
        return (
            <Switch>
                <Route
                    exact
                    path={`${url}/`}
                    component={asyncComponent(() => import('../Dashboard/index'))}
                />
                <Route
                    exact
                    path={`${url}/project/:projectId`}
                    component={asyncComponent(() => import('../ProjectDetail'))}
                />
                <Route
                    exact
                    path={`${url}/addnewproject`}
                    component={asyncComponent(() => import('../ProjectDetail/addProjectDetail'))}
                />
                <Route
                    exact
                    path={`${url}/addnewproject`}
                    component={asyncComponent(() => import('../ProjectDetail/addProjectDetail'))}
                />
                <Route
                    exact
                    path={`${url}/projects`}
                    component={asyncComponent(() => import('../ProjectList'))}
                />
                <Route
                    exact
                    path={`${url}/blankPage`}
                    component={asyncComponent(() => import('../blankPage'))}
                />
                <Route
                    exact
                    path={`${url}/contract`}
                    component={asyncComponent(() => import('../Contract'))}
                />
                <Route
                    exact
                    path={`${url}/contractoffer`}
                    component={asyncComponent(() => import('../IFrame/ContractOffer'))}
                />
                <Route
                    exact
                    path={`${url}/createoffer`}
                    component={asyncComponent(() => import('../IFrame/CreateOffer'))}
                />
                <Route
                    exact
                    path={`${url}/contractofferdetail/:actionId/:propertyId`}
                    component={asyncComponent(() => import('../IFrame/ContractOfferDetail'))}
                />
                <Route
                    exact
                    path={`${url}/employeecommission`}
                    component={asyncComponent(() => import('../IFrame/EmployeeCommission'))}
                />
                <Route
                    exact
                    path={`${url}/allemployeecommission`}
                    component={asyncComponent(() => import('../IFrame/AllEmployeeCommission'))}
                />
                <Route
                    exact
                    path={`${url}/salescommission`}
                    component={asyncComponent(() => import('../IFrame/SalesCommission'))}
                />
                <Route
                    exact
                    path={`${url}/setlanguages`}
                    component={asyncComponent(() => import('../IFrame/OfficeSettingLanguagePartial'))}
                />
                <Route
                    exact
                    path={`${url}/description`}
                    component={asyncComponent(() => import('../IFrame/PropertyDescription'))}
                />
                {/* <Route
                    exact
                    path={`${url}/setting`}
                    component={asyncComponent(() => import('../Setting'))}
                /> */}
                <Route
                    exact
                    path={`${url}/propertyReport`}
                    component={asyncComponent(() => import('../Report/PropertyReport'))}
                />
                <Route
                    exact
                    path={`${url}/saleReport`}
                    component={asyncComponent(() => import('../Report/SaleReport'))}
                    />
                <Route
                    exact
                    path={`${url}/deedDetail/`}
                    component={asyncComponent(() => import('../Deed'))}
                />
                <Route
                    exact
                    path={`${url}/dropdownSetting`}
                    component={asyncComponent(() => import('../IFrame/DropdownSettingIFrame'))}
                />
                <Route
                    exact
                    path={`${url}/textTemplateSetting`}
                    component={asyncComponent(() => import('../IFrame/TextTemplateSettingIFrame'))}
                />
                <Route
                    exact
                    path={`${url}/contact`}
                    component={asyncComponent(() => import('../IFrame/Contact'))}
                />
                <Route
                    exact
                    path={`${url}/enquiry`}
                    component={asyncComponent(() => import('../IFrame/Enquiry'))}
                />
                <Route
                    exact
                    path={`${url}/lead`}
                    component={asyncComponent(() => import('../IFrame/Lead'))}
                />
                <Route
                    exact
                    path={`${url}/account/contact`}
                    component={asyncComponent(() => import('../Contact'))}
                />
                <Route
                    exact
                    path={`${url}/account/enquiry`}
                    component={asyncComponent(() => import('../Enquiry'))}
                />
                <Route
                    exact
                    path={`${url}/account/enquiry/:enquiryId`}
                    component={asyncComponent(() => import('../Enquiry/enquiryDetail'))}
                />
                <Route
                    exact
                    path={`${url}/account/lead`}
                    component={asyncComponent(() => import('../Lead'))}
                />
                <Route
                    exact
                    path={`${url}/account/contact/:contactId`}
                    component={asyncComponent(() => import('../ContactDetail'))}
                />
                <Route
                    exact
                    path={`${url}/account/lead/:leadId`}
                    component={asyncComponent(() => import('../LeadDetail'))}
                />
                <Route
                    exact
                    path={`${url}/calendar`}
                    component={asyncComponent(() => import('../Calendar'))}
                />
                <Route
                    exact
                    path={`${url}/setting/employee`}
                    component={asyncComponent(() => import('../Setting/employee'))}
                />
                <Route
                    exact
                    path={`${url}/setting/employee/:employeeId`}
                    component={asyncComponent(() => import('../../components/setting/employeeSettingDetail'))}
                />
                <Route
                    exact
                    path={`${url}/setting/contactOrEnquiry`}
                    component={asyncComponent(() => import('../Setting/contactOrEnquiry'))}
                />
                <Route
                    exact
                    path={`${url}/setting/office`}
                    component={asyncComponent(() => import('../Setting/office'))}
                />
                <Route
                    exact
                    path={`${url}/setting/propertyOrProject`}
                    component={asyncComponent(() => import('../Setting/propertyOrProject'))}
                />
                <Route
                    exact
                    path={`${url}/properties`}
                    component={asyncComponent(() => import('../PropertyList'))}
                />
                <Route
                    exact
                    path={`${url}/property/:propertyId`}
                    component={asyncComponent(() => import('../PropertyDetail'))}
                />;
                <Route
                    exact
                    path={`${url}/addProperty`}
                    component={asyncComponent(() => import('../PropertyDetail/addProperty'))}
                />;
                <Route
                    exact
                    path={`${url}/setting/propertyList`}
                    component={asyncComponent(() => import('../IFrame/PropertyListSettingIFrame'))}
                />;
            </Switch>
        );
    }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/containers/App/AppRouter.tsx